import { createFetcher } from '../contexts/Fetcher';
import { apiProductRelease } from '../resources/api/apiProductRelease';
import { useParams } from 'react-router-dom';

interface IUrlParams {
  productId?: string;
}

const { useGetProductReleases } = apiProductRelease;

export const ReleasesFetcher = createFetcher(() => {
  const { productId } = useParams<IUrlParams>();
  return useGetProductReleases(productId).execute;
});
